import { useI18n } from 'vue-i18n';

// Tide/current/solunar event names arrive as English strings from the API and
// double as logic keys (icon slugs, sun/moon filtering in TidesStore), so they
// are translated at display time only. Unknown event names render as-is.
export function useTideEventName() {
  const { t, te } = useI18n();

  const translateTideEventName = (eventName) => {
    if (!eventName) return eventName;

    const words = eventName.replaceAll(',', '').toLowerCase().split(/\s+/);
    const camelName = words[0] + words.slice(1).map((w) => w[0].toUpperCase() + w.slice(1)).join('');
    const key = `containers.tides.events.${camelName}`;

    return te(key) || te(key, 'en') ? t(key) : eventName;
  };

  return { translateTideEventName };
}
